import { LoadingButton } from "@mui/lab";
import { Stack, Typography } from "@mui/material";
import { useSubscriptionRenew } from "hooks/api/useSubscriptionRenew";
import useNotifications from "hooks/useNotifications";

export const RenewForm = ({
    isDisabled,
    subscriptionId,
    setIsNotificationDialogOpen,
}) => {
    const { renew, isLoading } = useSubscriptionRenew();
    const { renderErrorNotification } = useNotifications();

    const handleRenew = async () => {
        try {
            await renew(subscriptionId);
            setIsNotificationDialogOpen(true);
        } catch (error) {
            console.error("Subscription renewal failed:", error);
            renderErrorNotification("Subscription renewal failed");
        }
    };

    return (
        <Stack direction="row" gap={2} p={2}>
            {isDisabled ? (
                <Typography variant="body2" sx={{ color: "grey.500" }}>
                    Subscriptions can only be renewed if they expired within the
                    last 3 days.
                </Typography>
            ) : (
                <LoadingButton
                    onClick={handleRenew}
                    loading={isLoading}
                    size="small"
                    color="primary"
                    variant="contained"
                    sx={{
                        px: "2rem",
                    }}
                >
                    Renew
                </LoadingButton>
            )}
        </Stack>
    );
};

export default RenewForm;
